/**
 * Which of the three apps this hostname serves.
 *
 * Lives here rather than in `App.tsx` because `ThemeProvider` needs the same answer and importing
 * it from `App.tsx` would close a cycle (App → AppLayout → ThemeToggle → ThemeContext → App).
 *
 * - admin.* → Super Admin + Internal Users
 * - merchant.* / partner.* → Merchants
 * - track.* / trk.* → Public tracking
 * - localhost → Admin app by default (dev); override with ?app=merchant / ?app=track
 */
export function detectAppFromHost(): 'admin' | 'merchant' | 'track' {
  const host = window.location.hostname;
  if (host.startsWith('merchant.') || host.startsWith('partner.')) return 'merchant';
  if (host.startsWith('track.') || host.startsWith('trk.')) return 'track';
  if (host.startsWith('admin.')) return 'admin';
  // Local dev: use ?app=merchant query string to test the merchant app
  const qs = new URLSearchParams(window.location.search).get('app');
  if (qs === 'merchant') return 'merchant';
  if (qs === 'track') return 'track';
  return 'admin';
}

/**
 * The public tracking page is opened by end customers from an SMS/WhatsApp link, with no account and
 * no saved preference. It owns its own theme (light by default) and the panel-wide ThemeProvider must
 * keep its hands off it — otherwise a customer whose phone is in dark mode gets the dark page.
 */
export const isPublicTrackHost = () => detectAppFromHost() === 'track';
